/**
 * Color Palette Constants
 *
 * Derived from `libs/ui/theme/src/scss/tokens/_colors.scss`
 */

export const BASE_COLORS = {
  'primary-100': '#DAD7D5',
  'primary-400': '#918F8E',
  'primary-700': '#3D3C3B',

  'accent-100': '#FFECB3',
  'accent-200': '#FFE082',
  'accent-400': '#FFCA28',
  'accent-700': '#FFA000',
};

export const COLORS = {
  'base-50': '#FAF9FA',
  'base-300': '#868488',
  'base-600': '#403C41',
  'base-700': '#2C2A30',
  'base-800': '#1F1D23',
  'base-900': '#141217',

  'primary-50': '#F2EFED',
  'primary-300': '#B5B3B2',
  'primary-500': '#727206F',
  'primary-600': '#5B5958',
  'primary-800': '#1D1D1C',
  'primary-900': '#1F1D22',

  'primary-a100': BASE_COLORS['primary-100'],
  'primary-a200': BASE_COLORS['primary-200'],
  'primary-a400': BASE_COLORS['primary-400'],
  'primary-a700': BASE_COLORS['primary-700'],

  'accent-50': '#FFF8E1',
  'accent-300': '#FFD54F',
  'accent-500': '#FFC107',
  'accent-600': '#FEC62E',
  'accent-800': '#FF8F00',
  'accent-900': '#FF6F00',
  'accent-a100': BASE_COLORS['accent-100'],
  'accent-a200': BASE_COLORS['accent-200'],
  'accent-a400': BASE_COLORS['accent-400'],
  'accent-a700': BASE_COLORS['accent-700'],

  'red-50': '#FFE8EF',
  'red-100': '#FFC9D2',
  'red-200': '#F06D73',
  'red-300': '#FC4A4F',
  'red-400': '#FC4A4F',
  'red-500': '#FF3535',
  'red-600': '#EF2A34',
  'red-700': '#DC192E',
  'red-800': '#D01227',
  'red-900': '#C10019',

  'pink-50': '#fce4ec',
  'pink-100': '#f8bbd0',
  'pink-200': '#f48fb1',
  'pink-300': '#f06292',
  'pink-400': '#ec407a',
  'pink-500': '#e91e63',
  'pink-600': '#d81b60',
  'pink-700': '#c2185b',
  'pink-800': '#ad1457',
  'pink-900': '#880e4f',

  'purple-50': '#FFFFFF',
  'purple-100': '#FFEEFF',
  'purple-200': '#EFC4FF',
  'purple-300': '#D098FF',
  'purple-400': '#B977FF',
  'purple-500': '#A556FF',
  'purple-600': '#9B53FB',
  'purple-700': '#8F48EF',
  'purple-800': '#8242E8',
  'purple-900': '#6B34D9',

  'deep-purple-50': '#ede7f6',
  'deep-purple-100': '#d1c4e9',
  'deep-purple-200': '#b39ddb',
  'deep-purple-300': '#9575cd',
  'deep-purple-400': '#7e57c2',
  'deep-purple-500': '#673ab7',
  'deep-purple-600': '#5e35b1',
  'deep-purple-700': '#512da8',
  'deep-purple-800': '#4527a0',
  'deep-purple-900': '#311b92',

  'indigo-50': '#e8eaf6',
  'indigo-100': '#c5cae9',
  'indigo-200': '#9fa8da',
  'indigo-300': '#7986cb',
  'indigo-400': '#5c6bc0',
  'indigo-500': '#3f51b5',
  'indigo-600': '#3949ab',
  'indigo-700': '#303f9f',
  'indigo-800': '#283593',
  'indigo-900': '#1a237e',

  'blue-50': '#ECFFFF',
  'blue-100': '#B6FFFF',
  'blue-200': '#9BE9FF',
  'blue-300': '#74CEFF',
  'blue-400': '#58BAFF',
  'blue-500': '#2AA5FD',
  'blue-600': '#0096EA',
  'blue-700': '#0081CF',
  'blue-800': '#006CB6',
  'blue-900': '#00569A',

  'light-blue-50': '#e1f5fe',
  'light-blue-100': '#b3e5fc',
  'light-blue-200': '#81d4fa',
  'light-blue-300': '#4fc3f7',
  'light-blue-400': '#29b6f6',
  'light-blue-500': '#03a9f4',
  'light-blue-600': '#039be5',
  'light-blue-700': '#0288d1',
  'light-blue-800': '#0277bd',
  'light-blue-900': '#01579b',

  'cyan-50': '#e0f7fa',
  'cyan-100': '#b2ebf2',
  'cyan-200': '#80deea',
  'cyan-300': '#4dd0e1',
  'cyan-400': '#26c6da',
  'cyan-500': '#00bcd4',
  'cyan-600': '#00acc1',
  'cyan-700': '#0097a7',
  'cyan-800': '#00838f',
  'cyan-900': '#006064',

  'teal-50': '#e0f2f1',
  'teal-100': '#b2dfdb',
  'teal-200': '#80cbc4',
  'teal-300': '#4db6ac',
  'teal-400': '#26a69a',
  'teal-500': '#009688',
  'teal-600': '#00897b',
  'teal-700': '#00796b',
  'teal-800': '#00695c',
  'teal-900': '#004d40',

  'green-50': '#F9FFE3',
  'green-100': '#E0FFC2',
  'green-200': '#C1FFA0',
  'green-300': '#A5FF7A',
  'green-400': '#90FF5A',
  'green-500': '#76F53B',
  'green-600': '#63E332',
  'green-700': '#4ECF92',
  'green-800': '#33BB22',
  'green-900': '#009714',
  'green-1000': '#8ed56a',

  'light-green-50': '#f1f8e9',
  'light-green-100': '#dcedc8',
  'light-green-200': '#c5e1a5',
  'light-green-300': '#aed581',
  'light-green-400': '#9ccc65',
  'light-green-500': '#8bc34a',
  'light-green-600': '#7cb342',
  'light-green-700': '#689f38',
  'light-green-800': '#558b2f',
  'light-green-900': '#33691e',

  'lime-50': '#f9fbe7',
  'lime-100': '#f0f4c3',
  'lime-200': '#e6ee9c',
  'lime-300': '#dce775',
  'lime-400': '#d4e157',
  'lime-500': '#cddc39',
  'lime-600': '#c0ca33',
  'lime-700': '#afb42b',
  'lime-800': '#9e9d24',
  'lime-900': '#827717',

  'yellow-50': '#fffde7',
  'yellow-100': '#fff9c4',
  'yellow-200': '#fff59d',
  'yellow-300': '#fff176',
  'yellow-400': '#ffee58',
  'yellow-500': '#ffeb3b',
  'yellow-600': '#fdd835',
  'yellow-700': '#fbc02d',
  'yellow-800': '#f9a825',
  'yellow-900': '#f57f17',

  'amber-50': '#FFFFFB',
  'amber-100': '#FFF3CE',
  'amber-200': '#FFE09B',
  'amber-300': '#FFCC66',
  'amber-400': '#FEBD41',
  'amber-500': '#FFB028',
  'amber-600': '#FBA522',
  'amber-700': '#F7961E',
  'amber-800': '#F08719',
  'amber-900': '#E96F12',

  'orange-50': '#fff3e0',
  'orange-100': '#ffe0b2',
  'orange-200': '#ffcc80',
  'orange-300': '#ffb74d',
  'orange-400': '#ffa726',
  'orange-500': '#ff9800',
  'orange-600': '#fb8c00',
  'orange-700': '#f57c00',
  'orange-800': '#ef6c00',
  'orange-900': '#e65100',

  'deep-orange-50': '#fbe9e7',
  'deep-orange-100': '#ffccbc',
  'deep-orange-200': '#ffab91',
  'deep-orange-300': '#ff8a65',
  'deep-orange-400': '#ff7043',
  'deep-orange-500': '#ff5722',
  'deep-orange-600': '#f4511e',
  'deep-orange-700': '#e64a19',
  'deep-orange-800': '#d84315',
  'deep-orange-900': '#bf360c',
  'deep-orange-a400': '#ff3d00',

  'brown-50': '#efebe9',
  'brown-100': '#d7ccc8',
  'brown-200': '#bcaaa4',
  'brown-300': '#a1887f',
  'brown-400': '#8d6e63',
  'brown-500': '#795548',
  'brown-600': '#6d4c41',
  'brown-700': '#5d4037',
  'brown-800': '#4e342e',
  'brown-900': '#3e2723',

  'grey-0': '#ffffff',
  'grey-50': '#fafafa',
  'grey-100': '#f5f5f5',
  'grey-200': '#eee',
  'grey-300': '#e0e0e0',
  'grey-400': '#bdbdbd',
  'grey-500': '#9e9e9e',
  'grey-600': '#757575',
  'grey-700': '#616161',
  'grey-800': '#424242',
  'grey-900': '#212121',

  'blue-grey-50': '#eceff1',
  'blue-grey-100': '#cfd8dc',
  'blue-grey-200': '#b0bec5',
  'blue-grey-300': '#90a4ae',
  'blue-grey-400': '#78909c',
  'blue-grey-500': '#607d8b',
  'blue-grey-600': '#546e7a',
  'blue-grey-700': '#455a64',
  'blue-grey-800': '#37474f',
  'blue-grey-900': '#263238',
};
